import fr from 'facet-rest';

export const metaOverrideSet = fr.metaOverride();
